var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Oil"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.9243 13.6363C22.5493 13.6363 23.0606 13.125 23.0606 12.5C23.0606 11.875 22.5493 11.3636 21.9243 11.3636H20.7879V4.54543H21.9243C22.5493 4.54543 23.0606 4.03407 23.0606 3.40907C23.0606 2.78407 22.5493 2.27271 21.9243 2.27271H3.74244C3.11744 2.27271 2.60608 2.78407 2.60608 3.40907C2.60608 4.03407 3.11744 4.54543 3.74244 4.54543H4.87881V11.3636H3.74244C3.11744 11.3636 2.60608 11.875 2.60608 12.5C2.60608 13.125 3.11744 13.6363 3.74244 13.6363H4.87881V20.4545H3.74244C3.11744 20.4545 2.60608 20.9659 2.60608 21.5909C2.60608 22.2159 3.11744 22.7273 3.74244 22.7273H21.9243C22.5493 22.7273 23.0606 22.2159 23.0606 21.5909C23.0606 20.9659 22.5493 20.4545 21.9243 20.4545H20.7879V13.6363H21.9243ZM12.8334 17.0454C10.947 17.0454 9.42426 15.5454 9.42426 13.6932C9.42426 12.2159 10.0152 11.7954 12.8334 8.5227C15.6402 11.7727 16.2424 12.2045 16.2424 13.6932C16.2424 15.5454 14.7197 17.0454 12.8334 17.0454Z",
    fill: "#313131"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOil);
export default __webpack_public_path__ + "static/media/Oil.277b7b7d56e226892062612345c4eb14.svg";
export { ForwardRef as ReactComponent };